import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import TreeGridItem from './item';
export default forwardRef(function TreeGridCell(_ref, ref) {
  let {
    children,
    withoutGridItem = false,
    ...props
  } = _ref;
  return createElement("td", _extends({}, props, {
    role: "gridcell"
  }), withoutGridItem ? children : createElement(TreeGridItem, {
    ref: ref
  }, children));
});
//# sourceMappingURL=cell.js.map